import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import type { RequestEncodeShortLinkInterface } from "./assistiveServiceApiInterface/postEncodeShortLinkInterface";
import { ResponseEncodeShortLinkPresenter } from "./assistiveServiceApiInterface/postEncodeShortLinkInterface";

class AssistiveServiceApi {
  private baseUrl: string;

  private basePath: string;

  private basePathV2: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "assistive";
    this.basePathV2 = "v2/assistive";
  }

  async postEncodeShortLink(
    params: RequestEncodeShortLinkInterface,
  ): Promise<ResponseEncodeShortLinkPresenter> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV2}/encodeShortLink`,
      "POST",
      params,
    )) as any;

    return new ResponseEncodeShortLinkPresenter(response);
  }

  async postDecodeShotLinkLink(
    params: RequestEncodeShortLinkInterface,
  ): Promise<ResponseEncodeShortLinkPresenter> {
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV2}/decodeShortLink`,
      "POST",
      params,
    )) as any;

    return new ResponseEncodeShortLinkPresenter(response);
  }
}

export default AssistiveServiceApi;
